/** Same MapTiler setup as go7 BookDelivery (MapTiler SDK — not Leaflet). */

export const MAPTILER_API_KEY =
  import.meta.env.VITE_MAPTILER_API_KEY || 'nRGZ9lGblbV9lFK2KclL';

/** Go7 cream cartoon style from customer app (home / overview) */
export const MAPTILER_STYLE_ID = '019996dd-306b-7019-acc5-de8469c0388d';

export const MAPTILER_STYLE_URL = `https://api.maptiler.com/maps/${MAPTILER_STYLE_ID}/style.json?key=${MAPTILER_API_KEY}`;

/** Streets + labels for en-route navigation (roads, street names) */
export const MAPTILER_NAV_STYLE_URL = `https://api.maptiler.com/maps/streets-v2/style.json?key=${MAPTILER_API_KEY}`;

export const ABEOKUTA_CENTER = { lat: 7.1575, lng: 3.347 };

/** Same ORS key pattern as go7/src/config/routing.js */
const ORS_FALLBACK =
  '5b3ce3597851110001cf6248444780b66afcc7b98a7484c91c39529820591b41';

export const ORS_API_KEY = import.meta.env.VITE_ORS_API_KEY || ORS_FALLBACK;
